import { DataBean } from "../DataBean";

export class TechnicianExperticies extends DataBean {

  public async getTechnicianExperticiesCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getTechnicianExperticiesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteTechnicianExperticies(idtechnicianexperticies: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteTechnicianExperticies_Number", [idtechnicianexperticies]);
  }

  public async updateTechnicianExperticies(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.TechnicianExperticies_updateTechnicianExperticies_com.orange.finance.processcontract.bean.TechnicianExperticies",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.TechnicianExperticies",
        },
      ]
    );
  }
}
